module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-90deg-right-8e8510a4.svg";